// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "086c5d039b5ae49db8f24a8783e9c3d0" + ".js";
};